import { APP_CONFIG } from 'mangools-commons/dist/configs/app'
import queryString from 'query-string';

import { parse, parseParams } from 'sources/parsers/KeywordsByDomainResultDataParser';

import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';
import HumanService from 'mangools-commons/dist/services/HumanService';

// Constants
const ENDPOINT = '/competitor-keywords';

const MAP_ORDER_BY_TO_API = {
    "serpPosition": "RANK",
    "searchCount": "SV",
    "estimatedTraffic": "EV",
    "cpc": "CPC",
    "ppc": "PPC"
}

/**
 * Data source class handling communication with API for result list data.
 */
class KeywordsByDomainResultSource {
    static getData({ accessToken, params }) {
        const requestURL = queryString.stringifyUrl({
            url: `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${ENDPOINT}`,
            query: {
                debug: 0,
                location_id: params.locationId,
                url: params.url,
                page: params.page,
                orderBy: MAP_ORDER_BY_TO_API[params.orderBy] || MAP_ORDER_BY_TO_API.serpPosition,
                orderByDirection: params.orderDirection === "ASC" ? 1 : -1,
                ts: new Date().getTime(),
            }
        });

        return fetch(requestURL, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-Access-Token': accessToken || '',
                'X-Human-Token': HumanService.gen(),
                'X-Mangools-Client': 'app',
            },
        })
            .then(response => {
                if (response.ok) {
                    if (response.status === 204) {
                        return {
                            error: false,
                            payload: {
                                data: {
                                    keywords: [],
                                },
                                params: {
                                    location: { id: params.locationId },
                                    query: params.query,
                                    urlType: params.urlType,
                                },
                            },
                        };
                    }

                    return response
                        .json()
                        .then(data => {
                            const parsedParams = parseParams(data);
                            parsedParams.query = params.query;

                            return {
                                error: false,
                                payload: {
                                    data: {
                                        keywords: parse(data),
                                        totalCount: data.totalCount,
                                        originalItemsCount: data.originalItemsCount,
                                    },
                                    isAllowedPagination: data.isAllowedPagination,
                                    params: parsedParams,
                                },
                            };
                        })
                        .catch(ex => ({
                            error: true,
                            payload: {
                                requestURL,
                                status: ErrorCodes.PARSE_ERROR,
                                text: ex.toString(),
                            },
                        }));
                } else {
                    return response.json().then(e => ({
                        error: true,
                        payload: {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                            retryAfter: e.error ? e.error.retry_after : null,
                        },
                    }));
                }
            })
            .catch(ex => ({
                error: true,
                payload: {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                },
            }));
    }
}

export default KeywordsByDomainResultSource;
